module.exports = __webpack_public_path__ + "static/images/circle-plus.2mjsbDt.svg";